import Product from './Product/Product';


const UserDatabaseConfig = {
    settings: {
      layout: {},
    },
    routes: [
      {
        path: 'userDataBases',
        element: <Product />,
      }
    ],
  };
  
  export default UserDatabaseConfig;
